document.addEventListener("DOMContentLoaded", () => {

    const links = document.querySelectorAll('.article-menu-link');
    const sections = [...links].map(l => document.querySelector(l.getAttribute('href')));

    links.forEach(link => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;

        // Add aspect ratio to lazy loaded images so that layout shift is minimized
        const section = target.closest('section');
        if (section) {
            section.querySelectorAll('img.lozad').forEach(img => {
                const width = img.getAttribute('width');
                const height = img.getAttribute('height');
                if (!img.style.aspectRatio && width && height) {
                    img.style.aspectRatio = `${width} / ${height}`;
                }
            });
        }

        link.addEventListener("click", e => {
            e.preventDefault();
            const target = document.querySelector(link.getAttribute('href'));
            if (target) {
                window.scrollTo({
                    top: target.offsetTop - 75,
                    behavior: "smooth"
                });
            }

            // mobile close
            if (document.body.classList.contains("active-menu")) {
                document.body.classList.remove("active-menu");
                document.getElementById("menu-icon").textContent = "Jump To";
            }
        });
    });

    const sectionToLinkMap = new Map();
    links.forEach(link => {
        const sectionElement = document.querySelector(link.getAttribute('href'));

        if (sectionElement) {
            sectionToLinkMap.set(sectionElement, link.parentElement);
        }
    });

    const observerCallback = (entries) => {
        entries.forEach(entry => {
            const linkParent = sectionToLinkMap.get(entry.target);

            if (!linkParent) return;

            if (entry.isIntersecting) {
                sectionToLinkMap.forEach(lp => lp.classList.remove('selected'));

                linkParent.classList.add('selected');
            }
        });
    };

    const headerHeight = 70;
    const observerOptions = {
        root: null,
        rootMargin: `-${headerHeight}px 0px -60% 0px`,
        threshold: 0
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    sections.forEach(section => {
        if (section) {
            observer.observe(section);
        }
    });

    // Show/hide jump-to icon
    window.addEventListener("scroll", () => {
        const icons = document.getElementById("menu-icons");
        if (!icons) return;
        if (window.scrollY > 0) {
            icons.classList.add("showicon");
        } else {
            icons.classList.remove("showicon");
        }
    });

    // Mobile toggle
    const menuIcon = document.getElementById("menu-icon");
    menuIcon?.addEventListener("click", () => {
        if (document.body.classList.contains("active-menu")) {
            document.body.classList.remove("active-menu");
            menuIcon.textContent = "Jump To";
        } else {
            menuIcon.innerHTML = '<i class="fa fa-times" aria-hidden="true"></i>';
            document.body.classList.add("active-menu");
        }
    });
});